import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

const borderColor = "#AAAAAA";
const specialBorderColor = "#F3F3F4";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F45B69",
    color: theme.palette.common.white,
    fontWeight: 700,
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#555555",
    border: `1px solid ${borderColor}`,
    verticalAlign: "baseline",
  },
  "&.bold-text": {
    fontWeight: 700,
  },
  "&:first-child": {
    borderLeft: `1px solid ${specialBorderColor}`,
  },
  "&:last-child": {
    borderRight: `1px solid ${specialBorderColor}`,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#CCE5E5",
  },
}));

const GlossaryTable = ({ isBold = false, rows }) => {
  return (
    <TableContainer sx={{ borderRadius: "13px" }}>
      <Table aria-label="customized table">
        <TableBody>
          {rows &&
            rows.map((row) => (
              <StyledTableRow>
                <StyledTableCell>{row.data1 && row.data1}</StyledTableCell>
                <StyledTableCell>{row.data2 && row.data2}</StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GlossaryTable;
